import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { SlinguAvatar } from './SlinguAvatar.js';
/**
 * Slingu companheiro flutuante no canto. Reage a qualquer clique na página
 * com uma animação de bump curta. Componentes podem disparar reações
 * programaticamente via `window.dispatchEvent(new CustomEvent('slingu:react'))`.
 */
export function SlinguGuide({ message, mood = 'wave', size = 84, minimized = false, onTap, onDismiss, }) {
    const [bubbleKey, setBubbleKey] = useState(0);
    const [reacting, setReacting] = useState(false);
    const timerRef = useRef(null);
    useEffect(() => {
        setBubbleKey((k) => k + 1);
    }, [message]);
    useEffect(() => {
        function bump() {
            if (timerRef.current)
                window.clearTimeout(timerRef.current);
            setReacting(true);
            timerRef.current = window.setTimeout(() => setReacting(false), 450);
        }
        function handleClick(e) {
            const target = e.target;
            if (!target)
                return;
            const interactive = target.closest('button, a, [role="button"], input[type="submit"]');
            if (!interactive)
                return;
            if (interactive.closest('.sl-guide'))
                return;
            bump();
        }
        function handleReact() {
            bump();
        }
        window.addEventListener('click', handleClick, true);
        window.addEventListener('slingu:react', handleReact);
        return () => {
            window.removeEventListener('click', handleClick, true);
            window.removeEventListener('slingu:react', handleReact);
            if (timerRef.current)
                window.clearTimeout(timerRef.current);
        };
    }, []);
    const rootClass = [
        'sl-guide',
        minimized ? 'sl-guide--minimized' : '',
        reacting ? 'sl-guide--react' : '',
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("div", { className: rootClass, "aria-live": "polite", children: [message && !minimized ? (_jsxs("div", { className: "sl-guide__bubble", role: "status", children: [onDismiss ? (_jsx("button", { type: "button", className: "sl-guide__dismiss", onClick: onDismiss, "aria-label": "Ocultar dica", children: "\u00D7" })) : null, message] }, bubbleKey)) : null, _jsx("button", { type: "button", className: "sl-guide__avatar", onClick: onTap, "aria-label": "Slingu, seu guia", children: _jsx(SlinguAvatar, { size: size, mood: reacting ? 'happy' : mood }) })] }));
}
//# sourceMappingURL=SlinguGuide.js.map